module.exports = __webpack_public_path__ + "static/media/cartagena.3d887be3.jpg";